import { Box, Button, Stack, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

import Icon from 'components/@icons/Icon';

import QuantityIndicator from './QuantityIndicator';

interface Props {
  quantity: number;
  isRemoveDisabled?: boolean;
  isAddDisabled?: boolean;
  size?: 'small' | 'medium';
  center?: ReactNode;
  sx?: SxProps<Theme>;
  onRemove: () => void;
  onAdd: () => void;
}

const AmountSelector = ({
  quantity,
  isRemoveDisabled = false,
  isAddDisabled = false,
  size = 'small',
  center,
  onRemove,
  onAdd,
  sx,
}: Props) => {
  const iconSize = size === 'medium' ? 24 : 18;

  return (
    <Stack
      direction="row"
      sx={[
        {
          alignItems: 'center',
        },
        size === 'medium' && {
          '& > .MuiButton-root': {
            flexShrink: 0,
            // Same Lama optical offset as kit contained medium icon buttons.
            '& svg': {
              mt: '-7px',
            },
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Button
        color="primary"
        variant="outlined"
        size={size}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onRemove();
        }}
        disabled={isRemoveDisabled}
        aria-label="Remove"
      >
        <Icon name="Minus" fontSize={iconSize} />
      </Button>
      {center ? (
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            minWidth: 0,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {center}
        </Box>
      ) : (
        <QuantityIndicator quantity={quantity} />
      )}
      <Button
        color="primary"
        variant="outlined"
        size={size}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onAdd();
        }}
        disabled={isAddDisabled}
        aria-label="Add"
      >
        <Icon name="Plus" fontSize={iconSize} />
      </Button>
    </Stack>
  );
};

export default AmountSelector;
